import React, { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import { IoIosArrowDown } from "react-icons/io";
import "../assets/css/setting.css";

const Settings = () => {
  const loginType = localStorage.getItem("loginType");
  const usernameTag = localStorage.getItem("user-nameTag");
  const [isSecurityOpen, setIsSecurityOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSecurityOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div ref={dropdownRef} className="row py-2 mt-2">
        <div className="col-md-4">
          <div className="settingSidebar p-4">
            <div className="username d-flex">
              <SettingsSharpIcon className="material-symbols-sharp settingIcon" />
              <div className="ms-3">
                <p className="f-14 mb-0">{usernameTag}</p>
                <span className="f-12 innerHeading">Setting</span>
              </div>
            </div>
            <ul>
              <NavLink to="profile">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/profile") ? "active" : ""
                  }`}
                >
                  <span>Profile</span>
                </li>
              </NavLink>

              {loginType === "Email" && (
                <NavLink to="changePassword">
                  <li
                    className={`navLinks ${
                      location.pathname.includes("/changePassword")
                        ? "active"
                        : ""
                    }`}
                  >
                    <span>Change Password</span>
                  </li>
                </NavLink>
              )}

              <NavLink to="pageNotification">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/pageNotification")
                      ? "active"
                      : ""
                  }`}
                >
                  <span>Notification</span>
                </li>
              </NavLink>

              <NavLink to="blockedUser">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/blockedUser") ? "active" : ""
                  }`}
                >
                  <span>Blocked users</span>
                </li>
              </NavLink>

              <li
                onClick={() => setIsSecurityOpen(!isSecurityOpen)}
                className={`navLinks pointer d-flex justify-content-between ${
                  isSecurityOpen ||
                  location.pathname.includes("privacy") ||
                  location.pathname.includes("manageSessions") ||
                  location.pathname.includes("2fAuth") ||
                  location.pathname.includes("changeEmailAddress")
                    ? "securityactive"
                    : ""
                }`}
              >
                <span>Security</span>
                <IoIosArrowDown className="dropdownIcon" />
              </li>

              {isSecurityOpen && (
                <ul className="dr">
                  <NavLink to="privacy">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/privacy") ? "active" : ""
                      }`}
                    >
                      <span>Privacy</span>
                    </li>
                  </NavLink>
                  <NavLink to="changePassword">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/changePassword")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>Password</span>
                    </li>
                  </NavLink>
                  <NavLink to="manageSessions">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/manageSessions")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>Manage Sessions</span>
                    </li>
                  </NavLink>
                  <NavLink to="2fAuth">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/2fAuth") ? "active" : ""
                      }`}
                    >
                      <span>2F - Auth</span>
                    </li>
                  </NavLink>
                  <NavLink to="changeEmailAddress">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/changeEmailAddress")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>Change Email Address</span>
                    </li>
                  </NavLink>
                </ul>
              )}

              <NavLink to="account">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/account") ? "active" : ""
                  }`}
                >
                  <span>Account</span>
                </li>
              </NavLink>
            </ul>
          </div>
        </div>
        <div className="col-md-8">
          <div className="settingSidebar">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
